package com.sweetlime.bingeamigo.di

import io.ktor.client.engine.HttpClientEngineFactory
import io.ktor.client.engine.js.Js

actual fun webHttpClientEngine(): HttpClientEngineFactory<*> = Js